import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/buyer-promotions")({
	component: BuyerPromotionsLayout,
})

function BuyerPromotionsLayout() {
	return <Outlet />
}
